export default __webpack_public_path__ + "static/media/FlyingFrog10.1dd4db59.png";